import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FinderIntersectionDirective } from './intersection.directive';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        FinderIntersectionDirective,
    ],
    providers: [],
    exports: [
        FinderIntersectionDirective,
    ],
})
export class FinderIntersectionModule {}
